import quickFetch from 'quick-fetch';
import http from 'hub-http/clients/apiClient';
const DM_API_BASE = 'designmanager/v1';
const COS_PAGES_API_BASE = 'cospages/v1/pages';
export const fetchThemeTemplates = (themePath, query) => {
  const THEME_TEMPLATES_EARLY_REQUEST_NAME = `templates-fetch`;
  const earlyRequest = quickFetch.getRequestStateByName(THEME_TEMPLATES_EARLY_REQUEST_NAME);
  let resultPromise;
  const themeTemplatesApiPath = `${DM_API_BASE}/templates/by-theme-path/${themePath}`;
  const fetchData = () => http.get(themeTemplatesApiPath, {
    query
  });
  if (earlyRequest) {
    resultPromise = new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(THEME_TEMPLATES_EARLY_REQUEST_NAME);
      });
      earlyRequest.onError(() => {
        fetchData().then(resolve, reject).catch(err => console.error(err));
        quickFetch.removeEarlyRequest(THEME_TEMPLATES_EARLY_REQUEST_NAME);
      });
    });
  } else {
    resultPromise = fetchData();
  }
  return resultPromise;
};
export const fetchThemePages = (themePath, query) => {
  const THEME_PAGES_EARLY_REQUEST_NAME = `pages-fetch`;
  const earlyRequest = quickFetch.getRequestStateByName(THEME_PAGES_EARLY_REQUEST_NAME);
  let resultPromise;
  const themePagesApiPath = COS_PAGES_API_BASE;
  const fetchData = () => http.get(themePagesApiPath, {
    query: Object.assign({}, query, {
      templatePath__startswith: themePath,
      limit: 700
    })
  });
  if (earlyRequest) {
    resultPromise = new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(THEME_PAGES_EARLY_REQUEST_NAME);
      });
      earlyRequest.onError(() => {
        fetchData().then(resolve, reject).catch(err => console.error(err));
        quickFetch.removeEarlyRequest(THEME_PAGES_EARLY_REQUEST_NAME);
      });
    });
  } else {
    resultPromise = fetchData();
  }
  return resultPromise;
};
export const fetchContentPreviewKey = contentId => {
  const PREVIEW_KEY_EARLY_REQUEST_NAME = `preview-info-${contentId}`;
  const earlyRequest = quickFetch.getRequestStateByName(PREVIEW_KEY_EARLY_REQUEST_NAME);
  let resultPromise;
  const previewKeyApiPath = `content-editor/v1/preview-key/${contentId}`;
  const fetchData = () => http.get(previewKeyApiPath);
  if (earlyRequest) {
    resultPromise = new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(PREVIEW_KEY_EARLY_REQUEST_NAME);
      });
      earlyRequest.onError(() => {
        fetchData().then(resolve, reject).catch(err => console.error(err));
        quickFetch.removeEarlyRequest(PREVIEW_KEY_EARLY_REQUEST_NAME);
      });
    });
  } else {
    resultPromise = fetchData();
  }
  return resultPromise;
};
export const fetchTemplate = templatePath => {
  return http.get(`${DM_API_BASE}/templates/by-path/${templatePath}`);
};